import { Directive, ElementRef, HostListener, forwardRef, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
	selector: '[vbUiSplitLinesInput]',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => VbUiSplitLinesInputDirective),
			multi: true,
		}
	],
	standalone: false
})
export class VbUiSplitLinesInputDirective implements ControlValueAccessor {
	private readonly nativeElement: HTMLInputElement;
	private onChange: (value: any) => void;
	public onTouched: () => void;

	constructor(
		Element: ElementRef,
		private readonly renderer : Renderer2
	) {
		this.nativeElement = Element.nativeElement;
	}

	@HostListener('input', ['$event.target.value'])
	public input(value: string): void {
		this.onTouched();
		this.onChange(this.parse(value));
	}

	@HostListener('blur')
	public onBlur(): void {
		this.onTouched();
	}

	public writeValue(value : string[]) : void {
		this.renderer.setProperty(this.nativeElement, 'value', this.format(value));
	}

	public registerOnChange( fn : any ) : void {
		this.onChange = fn;
	}

	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	private format(modelValue: string[]): string {
		return (modelValue || []).join('\n');
	}

	private parse(textInput: string): string[] {
		return textInput
			.split('\n')
			.filter(Boolean)
			.map(line => line.trim());
	}
}
